export const MARKET_SUBVERSION_MAP = {
    "nyc01": ["00","01","02"],
    "chi01":["01","02"],
    "phl01":["01","02"],
    "dc01":["01","02"],
    "la01":["01","02"],
    "bos01":["01","02"],
    "miami01":["01","02"],
    "fort_lau01":["01","02"],
    "nola01":["01","02"],
    "sanfran01":["01","02"],
    "wpb01":["01","02"],
    "sandi01":["01","02"],
    "buff01":["01","02"],
    "las01":["01","02"],
    "nyc02":["00","01"],
    "chi02":["00","01"],
    "phl02":["00","01"],
    "dc02":["00","01"],
    "la02":["00","01"],
    "bos02":["00","01"],
    "miami02":["00","01"],
    "fort_lau02":["00","01"],
    "nola02":["00","01"],
    "sanfran02":["00","01"],
    "wpb02":["00","01"],
    "sandi02":["00","01"],
    "las02":["00","01"],
    "buff02":["00","01"],
    "nyc03": ["00"],
    "chi03":["00"],
    "phl03":["00"],
    "dc03":["00"],
    "la03":["00"],
    "bos03":["00"],
    "miami03":["00"],
    "fort_lau03":["00"],
    "nola03":["00"],
    "reno03":["00"],
    "sanfran03":["00"],
    "wpb03":["00"],
    "ral03":["00"],
    "char03":["00"],
    "sandi03":["00"],
    "las03":["00"],
    "buff03":["00"],
    "sea03":["00"],
    "new03":["00"],
    "nyc04": ["00","01"],
    "chi04":["00","01"],
    "phl04":["00","01"],
    "dc04":["00","01"],
    "la04":["00","01"],
    "bos04":["00","01"],
    "miami04":["00","01"],
    "fort_lau04":["00","01"],
    "nola04":["00","01"],
    "reno04":["00","01"],
    "sanfran04":["00","01"],
    "wpb04":["00","01"],
    "ral04":["00","01"],
    "char04":["00","01"],
    "sandi04":["00","01"],
    "las04":["00","01"],
    "buff04":["00","01"],
    "sea04":["00"],
    "new04":["00"],
    "nyc05": ["00"],
    "chi05":["01"],
    "phl05":["00"],
    "dc05":["00"],
    "la05":["00"],
    "bos05":["00"],
    "miami05":["00"],
    "fort_lau05":["00"],
    "nola05":["00"],
    "reno05":["00"],
    "sanfran05":["00"],
    "wpb05":["00"],
    "ral05":["00"],
    "char05":["00"],
    "sandi05":["00"],
    "las05":["00"],
    "nyc06": ["00","01"],
    "chi06":["00","01"],
    "phl06":["00","01"],
    "dc06":["00","01"],
    "la06":["00","01"],
    "bos06":["00","01"],
    "miami06":["00","01"],
    "fort_lau06":["00","01"],
    "nola06":["00","01"],
    "sanfran06":["00","01"],
    "wpb06":["00","01"],
    "sandi06":["00","01"],
    "las06":["00","01"],
    "buff06":["00","01"],
    "nyc07": ["00"],
    "chi07":["00"],
    "nyc08": ["00"],
    "chi08":["00"],
    "phl08":["00"],
    "dc08":["00"],
    "la08":["00"],
    "bos08":["00"],
    "miami08":["00"],
    "fort_lau08":["00"],
    "nola08":["00"],
    "reno08":["00"],
    "sanfran08":["00"],
    "wpb08":["00"],
    "ral08":["00"],
    "char08":["00"],
    "sandi08":["00"],
    "las08":["00"],
    "nyc09": ["00"],
    "chi09":["00"],
    "phl09":["00"],
    "dc09":["00"],
    "la09":["00"],
    "bos09":["00"],
    "miami09":["00"],
    "fort_lau09":["00"],
    "nola09":["00"],
    "reno09":["00"],
    "sanfran09":["00"],
    "wpb09":["00"],
    "ral09":["00"],
    "char09":["00"],
    "sandi09":["00"],
    "las09":["00"],
    "sea09":["00"],
    "new09":["00"],
    "nyc10": ["00"],
    "chi10":["00"],
    "phl10":["00"],
    "dc10":["00"],
    "la10":["00"],
    "bos10":["00"],
    "miami10":["00"],
    "fort_lau10":["00"],
    "nola10":["00"],
    "reno10":["00"],
    "sanfran10":["00"],
    "wpb10":["00"],
    "ral10":["00"],
    "char10":["00"],
    "sandi10":["00"],
    "las10":["00"],
    "sea10":["00"],
    "la11":["00"],
    "nyc12": ["00"],
    "chi12":["00"],
    "phl12":["00"],
    "dc12":["00"],
    "la12":["00"],
    "bos12":["00"],
    "miami12":["00"],
    "fort_lau12":["00"],
    "nola12":["00"],
    "reno12":["00"],
    "sanfran12":["00"],
    "wpb12":["00"],
    "ral12":["00"],
    "char12":["00"],
    "sandi12":["00"],
    "las12":["00"],
    "sea12":["00"],
    "nyc13": ["00"],
    "new13":["00"],
    "chi13":["00"],
    "nyc14": ["00"],
    "new14":["00"],
    "chi14":["00"],
    "nyc15": ["00"],
    "new15":["00"],
    "chi15":["00"],
    "dc16":["00"],
    "la16":["00"],
    "reno16":["00"],
    "fort_lau16":["00"],
    "sanfran16":["00"],
    "wpb16":["00"],
    "miami16":["00"],
    "char16":["00"],
    "sea16":["00"],
    "ral16":["00"],
    "bos16":["00"],
    "dc17":["00"],
    "la17":["00"],
    "reno17":["00"],
    "wpb17":["00"],
    "miami17":["00"],
    "fort_lau17":["00"],
    "sanfran17":["00"],
    "sea17":["00"],
    "bos17":["00"],
    "dc18":["00"],
    "la18":["00"],
    "reno18":["00"],
    "wpb18":["00"],
    "miami18":["00"],
    "fort_lau18":["00"],
    "sanfran18":["00"],
    "char18":["00"],
    "sea18":["00"],
    "ral18":["00"],
    "bos18":["00"],
    "chi19": ["00"],
    "la19": ["00"],
    "ral19":["00"],
    "char19":["00"],
    "sandi19":["00"],
    "bos19":["00"],
    "las19":["00"],
    "chi20":["00"],
    "nyc20":["00"],
    "miami20":["00"],
    "wpb20":["00"],
    "fort_lau20":["00"],
    "la20":["00"],
    "reno20":["00"],
    "sanfran20":["00"],
    "char20":["00"],
    "sea20":["00"],
    "ral20":["00"],
    "bos20":["00"],
    "lon21":["00"],
    "sanfran22":["00"],
    "nyc23":["00"],
    "miami24":["00"],
    "miami25":["00"],
    "wpb25":["00"],
    "fort_lau25":["00"],
    "la25":["00"],
    "reno25":["00"],
    "sea25":["00"],
    "lon26":["00"],
    "lon27":["00"],
    "lon28":["00"],
    "lon29":["00"],
    "ral30":["00"],
    "char30":["00"],
    "lon31":["00"],
    "nyc32":["00"],
    "chi32":["00"],
    "phl32":["00"],
    "dc32":["00"],
    "la32":["00"],
    "bos32":["00"],
    "miami32":["00"],
    "fort_lau32":["00"],
    "nola32":["00"],
    "reno32":["00"],
    "sanfran32":["00"],
    "wpb32":["00"],
    "ral32":["00"],
    "char32":["00"],
    "sandi32":["00"],
    "las32":["00"],
    "buff32":["00"],
    "sea32":["00"],
    "chi33":["00"],
    "phl33":["00"],
    "dc33":["00"],
    "la33":["00"],
    "bos33":["00"],
    "miami33":["00"],
    "fort_lau33":["00"],
    "nola33":["00"],
    "reno33":["00"],
    "sanfran33":["00"],
    "wpb33":["00"],
    "ral33":["00"],
    "char33":["00"],
    "las33":["00"],
    "la34":["00"],
    "new35":["00"],
    "nyc36":["00"],
    "chi37":["00"],
    "bos38":["00"],
    "sandi39":["00"],
    "lon40":["00"],
}
